import { array, object, schema, string } from "@anna-money/anna-web-lib/serializer";
import { type Region } from "config/config";

export enum PartnerOfferType {
  Sprintlaw = "SPRINTLAW",
  Ionos = "IONOS",
  AdmiralBusinessInsurance = "ADMIRAL_BUSINESS_INSURANCE",
}

export class PartnerOfferData extends schema(
  {
    id: string(),
    type: string(),
    country: string(),
  },
  "PartnerOfferData",
) {}

export class PartnerOffersData extends schema(
  {
    offers: array(object(PartnerOfferData)),
    selectedOfferIds: array(string()),
  },
  "PartnerOffersData",
) {}

// The api client converts schemas to snake_case; a plain object would reach the backend as offerIds.
export class PartnerOffersSelectionData extends schema(
  {
    offerIds: array(string()),
  },
  "PartnerOffersSelectionData",
) {}

export interface PartnerOffer {
  id: string;
  type: PartnerOfferType;
  country: Region;
}

export type PartnerOfferSource = "card" | "modal";
